let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cU1bg")).then(() => parcelRequire('31Mvf'));